var _a;
import { handleActions } from 'redux-actions';
import { NAMES as VIDEO_SAVED_TIME_ACTIONS } from 'widget/redux/client/actions/player/set-saved-time';
export default handleActions((_a = {},
    _a[VIDEO_SAVED_TIME_ACTIONS.SET] = function (state, _a) {
        var payload = _a.payload;
        return payload;
    },
    _a), 0);
